import { render } from "./WelcomeLayout.vue?vue&type=template&id=68e01a4e"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js"

import "./WelcomeLayout.vue?vue&type=style&index=0&id=68e01a4e&lang=scss"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__